import { lightDark, secondary } from "styles/theme"
import { MarkingWordsCrud } from "."
import { useSelector } from "react-redux"
import { isEmpty } from "lodash"
import { markingWordsHooks } from ".."
import { useCallback, useContext } from "react"
import { useDispatch } from "react-redux"
import { actions } from "store"
import { useQueryClient } from "@tanstack/react-query"
import { queryClient as qc } from 'keys'
import { app } from "router/routes"
import { useLocation, useNavigate } from "react-router-dom"
import { adminAssessmentsHooks } from "../../AdminAssessments"
import { MarkingWordsContext } from "../MarkingWordsContext"

const useActionBtns = () => {
    const dispatch = useDispatch()
    const { assessment } = useSelector(state => state.assessment)
    const { words } = useSelector(state => state.words)
    const { state } = useLocation()
    const navigate = useNavigate()
    const queryClient = useQueryClient()

    const { saveDraft, loading: saveDraftLoading } = markingWordsHooks.useSaveDraft()
    const { saveComplete, loading: saveCompleteLoading } = markingWordsHooks.useSaveComplete()
    const selectAndViewAssessment = adminAssessmentsHooks.useSelectAndMarking()

    const completeDisabled = !assessment.timePoint?.word_def_id || saveCompleteLoading

    const markingWordsSaveAndNext = useCallback(async () => {
        await saveComplete()
        dispatch(actions.setStatusFilters(state.statusFilters))

        // const adminAssessments = await refetchAdminAssessments()
        const adminAssessments = queryClient.getQueriesData({ queryKey: [qc.adminAssessments] })
            ?.data

        let assessmentIndex = adminAssessments?.findIndex((ass) => ass.id === assessment.id)
        let assessmentLength = adminAssessments?.length

        if (assessmentIndex < assessmentLength - 1) {
            selectAndViewAssessment(adminAssessments[assessmentIndex + 1])
            dispatch(actions.setWords(null))
        }
        else navigate(app.markingWordsAssessments)
    }, [assessment, words])

    const markingWordsFinish = useCallback(async () => {
        await saveComplete()
        navigate(app.markingWordsAssessments)
    }, [assessment, words])

    const actionBtns = [
        {
            id: 0,
            label: saveDraftLoading || "הפסקה",
            action: saveDraft,
            color: "thirdly",
            loading: saveDraftLoading,
            width: 110,
            height: "35px",
            disabled: saveDraftLoading,
            disabledColor: "gray2"
        },
        {
            id: 2,
            label: saveCompleteLoading || "שמירה ומעבר למבדק הבא",
            action: markingWordsSaveAndNext,
            color: "secondary",
            loading: saveCompleteLoading,
            width: 200,
            disabled: completeDisabled,
            themeColor: secondary,
            disabledColor: "gray2",
            height: "35px"
        },
        {
            id: 3,
            label: saveCompleteLoading || "סיום",
            action: markingWordsFinish,
            color: "lightDark",
            loading: saveCompleteLoading,
            width: 80,
            disabled: completeDisabled,
            themeColor: lightDark,
            disabledColor: "gray2",
            height: "35px",
        }
    ]

    return actionBtns
}

export default useActionBtns
